import { useMutation, useQueryClient } from "@tanstack/react-query";

import { voidRefund } from "api/refund.api";
import {
  invalidateDashboardSources,
  invalidateRefundSide,
} from "lib/cacheInvalidation";

export const useVoidRefund = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason }) => voidRefund(id, { reason }),
    onSuccess: () => {
      invalidateRefundSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
